<template>
    <v-container fluid>
        <!-- Breadcrumbs -->
        <v-breadcrumbs
            :items="[
                { text: 'Home', disable: false, href: '/#/' },
                {
                    text: 'Inventory By Week',
                    disable: false,
                    href: '/#/customized/inventorybyweeksum'
                },
                { text: yearWeekText, disabled: true }
            ]"
            divider="/"
        ></v-breadcrumbs>

        <v-row class="ma-0">
            <v-col cols="12" class="pt-0">
                <v-hover>
                    <template v-slot="{ hover }">
                        <v-card :elevation="hover ? 6 : 1">
                            <v-card-title class="pb-0">
                                <v-icon color="primary" class="ml-2 mr-2"
                                    >extension</v-icon
                                >Inventory
                                <v-spacer></v-spacer>
                                <v-col cols="12" sm="4">
                                    <v-text-field
                                        dense
                                        v-model="search"
                                        append-outer-icon="refresh"
                                        @click:append-outer="
                                            refreshCurrentPage()
                                        "
                                        label="Search"
                                        clearable
                                        hide-details
                                        @keydown.enter="refreshCurrentPage()"
                                        @click:clear="onClearSearch()"
                                    ></v-text-field>
                                </v-col>
                                <v-spacer></v-spacer>
                            </v-card-title>

                            <v-container fluid>
                                <v-data-table
                                    :headers="headers"
                                    :loading="
                                        $apollo.queries
                                            .tenantPlantInventoryByWeek.loading
                                    "
                                    :items="tenantPlantInventoryByWeek.edges"
                                    :options.sync="dataTableOptions"
                                    :server-items-length="
                                        tenantPlantInventoryByWeek.totalCount
                                    "
                                    loading-text="Loading... Please wait"
                                    :items-per-page="defaultItemsPerPage"
                                    :footer-props="{
                                        'items-per-page-options': [
                                            10,
                                            25,
                                            50,
                                            75,
                                            100
                                        ],
                                        'disable-pagination':
                                            $apollo.queries
                                                .tenantPlantInventoryByWeek
                                                .loading
                                    }"
                                >
                                    <template
                                        v-slot:item.node.readySalesInventory="{
                                            item
                                        }"
                                    >
                                        <span class="mr-5"
                                            >{{ item.node.readySalesInventory }}
                                        </span>
                                    </template>

                                    <template
                                        v-slot:item.node.orderedInventory="{
                                            item
                                        }"
                                    >
                                        <v-icon
                                            color="warning"
                                            small
                                            left
                                            v-if="
                                                item.node
                                                    .notEnoughInventoryAlert
                                            "
                                            >warning</v-icon
                                        >
                                        <span class="mr-5"
                                            >{{ item.node.orderedInventory }}
                                        </span>
                                    </template>
                                </v-data-table>
                            </v-container>
                        </v-card>
                    </template>
                </v-hover>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import gql from "graphql-tag";

export default {
    name: "inventory-by-week",
    components: {},

    apollo: {
        tenantPlantInventoryByWeek: {
            query: gql`
                query tenantPlantInventoryByWeek(
                    $first: Int
                    $last: Int
                    $before: String
                    $after: String
                    $search: String
                    $orderBy: String
                    $readySalesYearWeek: String
                ) {
                    tenantPlantInventoryByWeek(
                        first: $first
                        last: $last
                        before: $before
                        after: $after
                        search: $search
                        orderBy: $orderBy
                        readySalesYearWeek: $readySalesYearWeek
                    ) {
                        edgeCount
                        totalCount
                        pageInfo {
                            startCursor
                            endCursor
                            hasPreviousPage
                            hasNextPage
                        }
                        edges {
                            node {
                                id
                                plant {
                                    id
                                    name
                                    plantSpecies {
                                        id
                                        name
                                    }
                                }
                                potSize {
                                    id
                                    potSizeCm
                                }
                                color {
                                    id
                                    color
                                }
                                environment {
                                    id
                                    environment
                                }
                                tag {
                                    id
                                    tag
                                }
                                readySalesInventory
                                orderedInventory
                                notEnoughInventoryAlert
                            }
                        }
                    }
                }
            `,
            variables() {
                return {
                    first: 10,
                    readySalesYearWeek: this.$route.params.yearWeek
                };
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: data => data.tenantPlantInventoryByWeek,
            skip: true,
            pollInterval: 60000 // ms
        }
    },

    data: function() {
        return {
            isLoadingInventory: false,

            search: "",

            defaultItemsPerPage: 25,
            dataTableOptions: {},
            page: 1,

            tenantPlantInventoryByWeek: {},

            headers: [
                // {
                //     text: "Week",
                //     value: "node.readySalesWeekStartDate",
                //     sortable: true
                // },
                {
                    text: "Plant Species",
                    value: "node.plant.plantSpecies.name",
                    sortable: true
                },
                {
                    text: "Plant",
                    align: "left",
                    value: "node.plant.name",
                    sortable: true
                },
                {
                    text: "Pot Size",
                    value: "node.potSize.potSizeCm",
                    sortable: true
                },
                {
                    text: "Color",
                    value: "node.color.color",
                    sortable: true
                },
                {
                    text: "Environment",
                    value: "node.environment.environment",
                    sortable: true
                },
                {
                    text: "Tag",
                    value: "node.tag.tag",
                    sortable: true
                },
                {
                    text: "Ready",
                    value: "node.readySalesInventory",
                    sortable: true
                },
                {
                    text: "Ordered",
                    value: "node.orderedInventory",
                    sortable: true
                }
            ],
            editedIndex: -1
        };
    },
    computed: {
        // inventory: function() {
        //     return this.$store.state.inventory.inventory;
        // }
        yearWeekText() {
            let _yearWeek = this.$route.params.yearWeek;
            return _yearWeek.slice(0, 4) + "-W" + _yearWeek.slice(4, 6);
        }
    },
    watch: {
        dataTableOptions: {
            handler() {
                this.refreshCurrentPage();
            },
            deep: true
        }
    },
    created() {
        this.initialize();
    },
    methods: {
        initialize() {
            // this.fetchInventory();
        },

        // fetchInventory() {
        //     // fetch plants
        //     this.isLoadingInventory = true;
        //     this.$store
        //         .dispatch("inventory/fetchGrowthTaskInventoryByPlant")
        //         .then(() => {
        //             // console.log("Fetched plants");
        //             // this.snackbarText = `${this.plants.length} plants fetched!`;
        //             // this.snackbar = true;
        //         })
        //         .catch(error => {
        //             /*handle errors*/
        //             console.log(error);
        //         })
        //         .finally(() => (this.isLoadingInventory = false));
        // }

        onClearSearch() {
            this.search = "";

            this.refreshCurrentPage();
        },

        refreshCurrentPage() {
            const {
                sortBy,
                sortDesc,
                page,
                itemsPerPage
            } = this.dataTableOptions;

            // console.log(sortBy, sortDesc, page, itemsPerPage);

            var _first = itemsPerPage;
            var _last = null;
            var _before = null;
            var _after = null;
            var _orderBy = null;

            if (page < this.page) {
                _first = null;
                _last = itemsPerPage;
                _before = this.tenantPlantInventoryByWeek.pageInfo.startCursor;
                _after = null;
            }

            if (page > this.page) {
                _first = itemsPerPage;
                _last = null;
                _before = null;
                _after = this.tenantPlantInventoryByWeek.pageInfo.endCursor;
            }

            switch (sortBy[0]) {
                case "node.plant.plantSpecies.name":
                    _orderBy = "plantSpeciesName";
                    break;
                case "node.plant.name":
                    _orderBy = "plantName";
                    break;
                case "node.potSize.potSizeCm":
                    _orderBy = "potSize";
                    break;
                case "node.color.color":
                    _orderBy = "color";
                    break;
                case "node.environment.environment":
                    _orderBy = "environment";
                    break;
                case "node.tag.tag":
                    _orderBy = "tag";
                    break;
                case "node.readySalesInventory":
                    _orderBy = "readySalesInventory";
                    break;
                case "node.orderedInventory":
                    _orderBy = "orderedInventory";
                    break;
                case "node.readySalesWeekStartDate":
                    _orderBy = "readySalesWeekStartDate";
                    break;
                default:
                    _orderBy = null;
                    break;
            }

            if (sortDesc[0] === true) {
                _orderBy = "-" + _orderBy;
            }

            this.$apollo.queries.tenantPlantInventoryByWeek.setVariables({
                first: _first,
                last: _last,
                before: _before,
                after: _after,
                orderBy: _orderBy,
                search: this.search,
                readySalesYearWeek: this.$route.params.yearWeek
            });

            // set skip false to execute the query
            this.$apollo.queries.tenantPlantInventoryByWeek.skip = false;
            this.$apollo.queries.tenantPlantInventoryByWeek.refresh();

            // update this.page
            this.page = page;
        }
    }
};
</script>